export const iconFontAwesomeSpinnersPalette = (
	<i className="fa-solid fa-palette"></i>
);
